import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import { HashRouter } from "react-router-dom";
import './index.less';
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('en');

ReactDOM.render(
    <ConfigProvider locale={zhCN}>
        <HashRouter>
            <App />
        </HashRouter>
    </ConfigProvider>,
    document.getElementById('root')
);

reportWebVitals();
